import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthorizeZoomMutation } from '../../api/taxProConsultationApi';

/** Component to handle Zoom OAuth redirects */
const ZoomOAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [authorizeZoom] = useAuthorizeZoomMutation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');

    authorizeZoom({ code, state });
    navigate('/dashboard');
  }, [location, authorizeZoom, navigate]);

  return <div>Connecting Zoom...</div>;
};

export default ZoomOAuthCallback;
